import { createAppI18n, sharedTranslations, type TKeyOf } from '@repo/i18n'
import { operatorTranslations } from '@/routes/-translations/operator-translations'
import { operatorAuditTranslations } from '@/routes/(private)/audit/-translations/operator-audit-translations'
import { operatorsTranslations } from '@/routes/(private)/operators/-translations/operators-translations'
import { organizationsTranslations } from '@/routes/(private)/organizations/-translations/organizations-translations'
import { acceptInviteTranslations } from '@/routes/accept-invite/$code/-translations/accept-invite-translations'
import { commonTranslations } from '@/translations/common-translations'

/**
 * App-owned i18n facade. The engine and the shared `shared` namespace (text
 * built into `@repo/ui` components) live in `@repo/i18n`; the app's own
 * `common` namespace and feature namespaces live here. App code keeps importing
 * from `@/lib/i18n`.
 */
const resources = {
	en: {
		common: commonTranslations.en,
		shared: sharedTranslations.en,
		operator: operatorTranslations.en,
		'operator-organizations': organizationsTranslations.en,
		'operator-audit': operatorAuditTranslations.en,
		'operator-operators': operatorsTranslations.en,
		'operator-accept-invite': acceptInviteTranslations.en
	},
	it: {
		common: commonTranslations.it,
		shared: sharedTranslations.it,
		operator: operatorTranslations.it,
		'operator-organizations': organizationsTranslations.it,
		'operator-audit': operatorAuditTranslations.it,
		'operator-operators': operatorsTranslations.it,
		'operator-accept-invite': acceptInviteTranslations.it
	}
} as const

const appI18n = createAppI18n(resources, { defaultNS: 'common' })

export const { useTranslation, Trans, translateApp } = appI18n

/**
 * All translation keys with namespace prefix (e.g.
 * `shared:http_errors.default`).
 */
export type TKey = TKeyOf<(typeof resources)['en']>

const i18n = appI18n.i18n

export default i18n

export {
	APP_LANGUAGES,
	type AppLanguage,
	type AppLanguageCode,
	changeAppLanguage,
	DEFAULT_LANGUAGE,
	detectAppLanguageFromRequest,
	getInitialAppLanguage,
	isAppLanguageCode,
	onAppLanguageChange,
	resolveAppLanguageCode,
	syncAppLanguage,
	translateKey
} from '@repo/i18n'
